// Display the recorded category verbatim; do not collapse storage subtypes.
export const normalizeWikiCategoryLabel = category => String(category || '').trim()
